/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Investmentphase2Inputs */

const en_usermanagement_help_investmentphase2 = /** @type {(inputs: Usermanagement_Help_Investmentphase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the <b>Investment Phase</b>, the focus shifts to monitoring and managing the investment. Users invited during this phase help to operate finances, manage legal documents, and handle ongoing reporting.`)
};

/**
* | output |
* | --- |
* | "In the <b>Investment Phase</b>, the focus shifts to monitoring and managing the investment. Users invited during this phase help to operate finances, manage ..." |
*
* @param {Usermanagement_Help_Investmentphase2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_investmentphase2 = /** @type {((inputs?: Usermanagement_Help_Investmentphase2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Investmentphase2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_investmentphase2(inputs)
});
export { usermanagement_help_investmentphase2 as "userManagement_help_investmentPhase" }